import {
	FormControlLabel,
	Checkbox as MuiCheckbox,
	FormControl,
	FormLabel,
	FormGroup,
	FormHelperText,
} from "@mui/material";
import CommonUtil from "@utils/utility";
import { MvCheckboxGroupPropsInterface } from "@mv-components/types";

const CheckboxGroup = (props: MvCheckboxGroupPropsInterface) => {
	const { value, options, label, onChange, itemKey, topHelperText = false } = props;

	return (
		<FormControl error={CommonUtil.isError(props)} component="fieldset" variant="standard">
			{!!label && <FormLabel component="legend">{label}</FormLabel>}

			{topHelperText && CommonUtil.getHelperTxt(props) && (
				<FormHelperText>{CommonUtil.getHelperTxt(props)}</FormHelperText>
			)}

			<FormGroup>
				{options?.map((option) => {
					return (
						<FormControlLabel
							key={option.value}
							control={
								<MuiCheckbox
									checked={value[option.value] || false}
									onChange={(event, checked) => {
										const newValue = { ...value };
										if (!checked && typeof newValue[option.value] !== "undefined") {
											// eslint-disable-next-line @typescript-eslint/no-dynamic-delete
											delete newValue[option.value];
										} else if (checked) {
											newValue[option.value] = checked;
										}

										onChange({
											event,
											itemKey,
											value: newValue,
										});
									}}
									name={option.value}
								/>
							}
							label={option.label}
						/>
					);
				})}
			</FormGroup>
		</FormControl>
	);
};

export default CheckboxGroup;
